export type DockScrollState = { compact: boolean; anchor: number };

export const clampScroll = (offset: number, maximum: number) =>
  Math.max(0, Math.min(offset, Math.max(0, maximum)));

export function initialDockState(offset: number): DockScrollState {
  return { compact: offset > 64, anchor: offset };
}

/** Accumulate travel from the direction's extreme, absorbing small reversals. */
export function advanceDockState(
  state: DockScrollState,
  offset: number
): DockScrollState {
  if (offset <= 8) return { compact: false, anchor: offset };
  const anchor = state.compact
    ? Math.max(state.anchor, offset)
    : Math.min(state.anchor, offset);
  const change = state.compact
    ? anchor - offset >= 8
    : offset > 64 && offset - anchor >= 12;
  return change
    ? { compact: !state.compact, anchor: offset }
    : { compact: state.compact, anchor };
}
